import { ReactComponent as IconDataElement } from '@/assets/svgs/data-element.svg'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import { ReactComponent as IconSearch } from '@/assets/svgs/icon-search.svg'
import { ReactComponent as IconImport } from '@/assets/svgs/import-data.svg'
import Button from '@/components/Button/index'
import InputSuffixIcon from '@/components/InputSuffixIcon'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import useEclips from '@/hooks/use-eclips/index'
import usePackages from '@/hooks/use-packages/index.js'
import { useParams } from '@/lib/router-dom/index'
import rem from '@/utils/rem'
import { useState } from 'react'
import DataElementsList from './data-elements-list.jsx'
import PackagesList from './packages-list.jsx'
import { feature, features } from '@/utils/feature-verifier';
import Search from '@/componentsDS/Search/index';


export default function ImportDataModal({
	visible,
	dataElement,
	close,
	submit,
	version = 'v1',
}) {
	const [search, setSearch] = useState('')
	const [selected, setSelected] = useState('')

	// const params = useParams()
	const { eclipId } = useParams();
	const { importMessageData } = useEclips()
	const { importMessageData: importMessageData_usePackage } = usePackages()

	const handleImportDataElementSubmit = async () => {
		close();
		if (version === 'v2') {
			await importMessageData_usePackage(eclipId, selected,{
				parent_node_id: dataElement.parent_node_id,
				parent_node_type: dataElement.parent_node_type,
				recipientOrgId: dataElement?.selectedRecipient[0]?.id,
				onBehalfOrgId: dataElement?.selectedOnBehalfOf[0]?.id,
			})
		} else {
			await importMessageData(eclipId, selected)
		}
		submit()
	}

	return (
		<Modal visible={visible} variant='large' close={close}>
			<CardConfigure >
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconImport />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Import Received Data Element
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="card-configure__sub-header">
							<div className="data-element__import">
								<span>Data element that you are importing</span>
								<div className={`eclip-landing-eclip-box dark-box`}>
									<IconDataElement />
								</div>
								<span>{dataElement?.elementName || '-'}</span>
							</div>
						</div>
						<div className="data-element__import-search-input">
							<Search
								value={search}
								placeholder='Search by package name or reference ID'
								onChange={(e) => setSearch(e?.target.value)}
								onCancel={() => setSearch('')}
							/>
						</div>
						<div></div>
						<div className="data-element__import-list-group">
							<PackagesList
								dataElementId={dataElement?.dataElementId}
								search={search}
								visible={visible}
								selected={selected}
								handlePackageSelection={setSelected}
								version={version}
							/>
							<div className="gap">or</div>
							<DataElementsList
								dataElementId={dataElement?.dataElementId}
								search={search}
								visible={visible}
								selected={selected}
								handleMessageSelection={setSelected}
							/>
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={close} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button
							disabled={!selected}
							text="Select & Import"
							submit={handleImportDataElementSubmit}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
